module.exports = ".card img{\r\n    width:100%;\r\n    height: 150px;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/add-outlet/add-outlet.component.css
// module id = ./src/app/add-outlet/add-outlet.component.css
// module chunks = main